import type { PcGlobalContactChatOpenTime } from '@/api/types/common';

/** 从 BFF `json_values.contact_chat_open_time` 解析客服在线时段（支持魔方 `json_value` 包裹） */
export function parseBffContactChatOpenTime(raw: unknown): PcGlobalContactChatOpenTime | null {
  if (raw == null) {
    return null;
  }
  let candidate: unknown = raw;
  if (typeof candidate === 'object' && candidate !== null && 'json_value' in candidate) {
    candidate = (candidate as { json_value?: unknown }).json_value;
  }
  if (candidate == null || typeof candidate !== 'object') {
    return null;
  }
  const r = candidate as Record<string, unknown>;
  const start = r.start;
  const end = r.end;
  if (typeof start === 'string' && typeof end === 'string') {
    return { start, end };
  }
  return null;
}
